
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { ProjetoCadastro } from '../../../models/projeto-cadastro.model';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';
import { environment } from 'src/environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-projeto-abas-edit',
  templateUrl: './projeto-abas-edit.component.html',
  styleUrls: ['./projeto-abas-edit.component.scss'],
})
export class ProjetoAbasEditComponent
  extends BaseFormComponent<ProjetoCadastro>
  implements OnInit
{
  question: any;
  disabledBtn: boolean = true;
  lastTabGroupName: string = '';
  audit: AtualizacoesAudit;
  modalCloneRef?: BsModalRef;
  clone_title: string;

  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    private myService: ProjetoCadastroService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private modalService: BsModalService,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.entity = this.activatedRoute.snapshot.data['entity'];
      this.initForm();
      this.loaded();
    });
  }

  initForm() {
    this.form = new FormGroup({
      questions: new FormArray([]),
    });

    if (this.entity?.id) {
      this.audit = {
        pp_id: this.entity?.id,
      };
      this.populateFields();
      this.disabledBtn = this.entity?.can_save && !this.entity?.readonly;
      if (this.entity?.readonly) this.form.disable();
    }
  }

  populateFields() {
    if (this.entity?.questions?.length) {
      const formGroup = {};
      this.entity.questions.forEach((field) => {
        formGroup[field.question_id] = new FormGroup({
          question_id: new FormControl(field.question_id),
          ds_value: new FormControl(
            field.ds_value,
            !field.allow_null ? [Validators.required] : []
          ),
        });
      });
      this.getFormArray('questions').push(new FormGroup(formGroup));
    }
  }

  populateList(formArrayName: string, idFieldName: string) {
    if (this.entity?.[formArrayName]?.length) {
      this.getFormArray(formArrayName).clear();
      this.entity[formArrayName].forEach((item) => {
        this.getFormArray(formArrayName).push(
          new FormControl(item[idFieldName])
        );
      });
    }
  }

  getFormArray(form: string): FormArray {
    return this.form.get(form) as FormArray;
  }

  getControl(form: string) {
    const formGroup = this.getFormArray('questions').at(0)?.['controls']?.[
      form
    ] as FormGroup;
    return formGroup?.get('ds_value');
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'projeto']);
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro = { ...this.form.value };
    if (this.entity?.questions) {
      this.entity.questions.forEach((field) => {
        if (field.type_id == this.entity?.ppQuestion['TYPE_DATA']) {
          const formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
          const dataSimples = this.getControl(field.question_id)?.value;
          if (dataSimples && !formatoDataRegex.test(dataSimples)) {
            data.questions[0][field.question_id].ds_value = formatDate(
              dataSimples,
              'DD/MM/YYYY'
            );
          }
        }
      });
      data.questions = data.questions[0];
    }
    return data;
  }

  update(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id && this.entity?.can_save) {
        this.addSub(
          this.myService
            .updateTabs(this.getDataCreate(), this.entity.id)
            .subscribe({
              next: () => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  fieldMessageRequireds(form: string): boolean {
    return this.getControl(form)?.invalid && this.getControl(form)?.dirty;
  }

  fieldErrosFormArray(form: string) {
    return this.getControl(form)?.errors;
  }

  clearInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    input.value = '';
  }

  formatarMedidaFisica(field: string, decimal: number = 2) {
    let value = this.maskService.formatarMedidaFisica(
      this.form.get(field)?.value,
      decimal
    );
    this.form.get(field).setValue(value);
  }

  formatarMedidaFisica2(form, decimal = 2) {
    let value = this.maskService.formatarMedidaFisica(
      this.getControl(form)?.value,
      decimal
    );
    this.getControl(form)?.setValue(value);
  }

  shouldShowHeader(currentTabGroupName: string, index: number): boolean {
    if (index === 0 || currentTabGroupName !== this.lastTabGroupName) {
      this.lastTabGroupName = currentTabGroupName;
      return true;
    }
    return false;
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.entity?.id && this.entity?.can_clone) {
      const obj = {
        clone_id: this.entity?.id,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.myService.clonar(obj).subscribe({
          next: () => {
            this.msgSuccess('Clonado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.entity?.id}`;
    this.loaded();
    window.open(url, '_blank');
  }
}

